import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import * as styles from './ProgressBar.css';

const cx = classnames.bind(styles);

export function ProgressBar({ testId = 'progress-bar', className, progressValue = 0, ...props }) {
    const classes = cx('base', className);

    return (
        <progress
            max="100"
            data-testid={testId}
            className={classes}
            value={Math.round(progressValue * 100)}
            {...props}
        />
    );
}

ProgressBar.propTypes = {
    /**
     * Emit a `data-testid` prop on the root element of the component. Use this
     * to help automated testing tools find this particular component.
     */
    testId: PropTypes.string,

    /**
     * Set additional CSS classes on the component to extend the default styles.
     */
    className: PropTypes.string,

    /**
     * The amount of progress to show on the bar, 0 (none) to 1 (completed)
     */
    progressValue: PropTypes.number
};
